import StubPage from '../../components/StubPage.jsx';

export default function HostingPage() {
  return (
    <StubPage
      title="Hosting & performance"
      description="Cloud hosting, CDN, custom domains, and backups."
      planned={[
        'Custom domains with automatic TLS',
        'Global CDN with image optimization and lazy-loading',
        'Auto-scaling infrastructure with 99.95% uptime SLA',
        'Per-site daily backups with point-in-time restore',
        'Per-site uptime + Lighthouse performance dashboard',
      ]}
    />
  );
}
